import styled from '@emotion/styled'
import { getTargetedPortal } from '@retailer-platform/shared-components'

const [PortalTarget, Portal] = getTargetedPortal()

export const RetailerCollectionsFormFooterPortal = Portal
export const RetailerCollectionsFormFooter = styled(PortalTarget)({
  display: 'contents',
})
